export default __webpack_public_path__ + "assets/apple-icon-72x72.135550a0dc715f67dbb24b778e5a122e.png";